import Immutable from 'immutable';
import {
  START_FETCH_PROGRESS_PAGE_DATA,
  SET_PROGRESS_PAGE_DATA,
} from './actions';

const DEFAULT_STATE = Immutable.fromJS({
  isLoading: false,
  hasLoaded: false,
  moduleList: [],
  cohortSchedule: {},
});

export function ProgressPage(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case START_FETCH_PROGRESS_PAGE_DATA: {
      return state.set('isLoading', true);
    }
    case SET_PROGRESS_PAGE_DATA: {
      const { moduleList, cohortSchedule } = action;

      return state.merge({
        isLoading: false,
        hasLoaded: true,
        moduleList: Immutable.fromJS(moduleList),
        cohortSchedule: Immutable.fromJS(cohortSchedule),
      });
    }
    default: {
      return state;
    }
  }
}
